import { useSearchParams } from "react-router-dom";

// URL-synced filter/sort state: shareable and survives refresh.
export function useUrlFilters(keys = []) {
  const [sp, setSp] = useSearchParams();

  const values = {};
  keys.forEach((k) => { values[k] = sp.get(k) || ""; });

  const setFilter = (k, v) => {
    const next = new URLSearchParams(sp);
    if (v === undefined || v === null || v === "" || v === "all") next.delete(k);
    else next.set(k, v);
    setSp(next, { replace: false });
  };

  const clearAll = () => {
    const next = new URLSearchParams(sp);
    keys.forEach((k) => next.delete(k));
    setSp(next, { replace: false });
  };

  const activeCount = keys.filter((k) => values[k]).length;

  return { values, setFilter, clearAll, activeCount };
}
